<template>
  <div class="base-menu-500-wrapper row mx-auto  ">
    <template v-for="menu in storeMenus" :key="menu.id">
      <template v-if="menu.position === menuPosition">
        <base-menu-item
            v-for="item in menu.children"
            :key="item.id"
            :item="item"
        />
      </template>
    </template>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { MenuProps } from './MenuProps'
import BaseMenuItem from './BaseMenuItem500.vue'

export default {
  name: 'BaseMenu500',
  components: { BaseMenuItem },
  props: {
    ...MenuProps
  },
  computed: {
    ...mapGetters({
      storeMenus: 'Menu/getAllMenus',
      isAuth: 'User/isAuthenticated',
      orderCount: 'ShoppingCart/getSidebarBasketData',
    }),
  },
}
</script>

<style scoped>
.base-menu-500-wrapper {
  position: relative;
  direction: rtl;
}
</style>
